import { z } from "zod";

const FirestoreDocument = z.object({
	id: z.string(),
	ref: z.any(),
});

export default FirestoreDocument;
